const saveToken = (token: string) => localStorage.setItem("token", token);

const getToken = () => localStorage.getItem("token");

export const localStorageApi = { saveToken, getToken };
